import { useCallback, useState } from 'react';

import { HealthProviderFeatureList } from '../../../compositions/features/list/health-provider-feature-list';
import { HealthProviderFeatureModal } from '../../../compositions/features/modals/health-provider-feature-modal/health-provider-feature-modal';
import { useHealthProviderFeatureItems } from '../../../data/data/features/use-health-provider-feature-items';
import { useCurrentHealthProvider } from '../../../data/data/health-providers/use-current-health-provider';
import { HealthProviderFeatureItemDataFragment } from '../../../data/types/api/graphql';
import { Content } from '../../../elements/content/content';

export function AdminFeaturesPage() {
  const { healthProvider } = useCurrentHealthProvider();
  const [healthProviderFeatureModalOpen, setHealthProviderFeatureModalOpen] =
    useState<HealthProviderFeatureItemDataFragment | false>(false);

  const {
    data: healthProviderFeatureItemsData,
    loading: healthProviderFeatureItemsLoading,
  } = useHealthProviderFeatureItems({
    healthProviderId: healthProvider?.id,
  });

  const onHandleHealthProviderFeature = useCallback(
    (value: HealthProviderFeatureItemDataFragment) => {
      setHealthProviderFeatureModalOpen(value);
    },
    []
  );

  return (
    <>
      <Content>
        <HealthProviderFeatureList
          loading={healthProviderFeatureItemsLoading}
          items={healthProviderFeatureItemsData}
          onClick={onHandleHealthProviderFeature}
        />
      </Content>
      {healthProviderFeatureModalOpen && healthProvider && (
        <HealthProviderFeatureModal
          healthProvider={healthProvider}
          healthProviderFeatureItemData={healthProviderFeatureModalOpen}
          onClose={() => {
            setHealthProviderFeatureModalOpen(false);
          }}
        />
      )}
    </>
  );
}
